var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeftCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.016,
    height: 24.567,
    viewBox: "0 0 24.016 24.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-left-circle",
    "data-name": "Icon feather-arrow-left-circle",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37639",
    "data-name": "Path 37639",
    d: "M25.016,14.283A11.148,11.148,0,0,1,14.008,25.567,11.148,11.148,0,0,1,3,14.283,11.148,11.148,0,0,1,14.008,3,11.148,11.148,0,0,1,25.016,14.283Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#61277F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37640",
    "data-name": "Path 37640",
    d: "M16.029,12,12,16.029l4.029,4.029",
    transform: "translate(-5.255 -4.746)",
    fill: "none",
    stroke: "#61277F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37641",
    "data-name": "Path 37641",
    d: "M20.058,18H12",
    transform: "translate(-5.021 -6.717)",
    fill: "none",
    stroke: "#61277F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrow-left-circle.c82d4f02c681e8412a3bcc3aa724365a.svg";
export { ForwardRef as ReactComponent };